import { GridItem, Box } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { allCoverablesOnsaAtom } from '../../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCoverable } from '../../../../../utils/coverablesUtil';
import type {
    PrhHolidayHomeOnsaDTO,
    PrhHouseOnsaDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/house';
import HouseInputDeductible from './HouseInputDeductible';
import HolidayHomeInputManualSum from './HolidayHomeInputManualSumInputManualSum';
import HolidayHomeInputSum from './HolidayHomeInputSum';
import { COVERABLE_CODE } from '../../../../../constants/coverable';

const CoveragePackageHouseInput = ({
    isLoading,
    setIsLoading
}: {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
    const {
        flavourName = '',
        fixedId = '',
        flavourCode
    } = useRecoilValue(getOnsaCurrentProductSelector);
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId) as
        | PrhHouseOnsaDTO
        | PrhHolidayHomeOnsaDTO;

    const holidayHomeInsuranceSum = (coverable as PrhHolidayHomeOnsaDTO).contentInsuranceSum;

    return (
        <GridItem span={7}>
            <Box>
                <HouseInputDeductible isLoading={isLoading} setIsLoading={setIsLoading} />
                {flavourCode === COVERABLE_CODE.prhHolidayHome && (
                    <HolidayHomeInputSum isLoading={isLoading} setIsLoading={setIsLoading} />
                )}
                {holidayHomeInsuranceSum !== undefined &&
                    isNaN(parseInt(holidayHomeInsuranceSum ?? '')) && (
                        <HolidayHomeInputManualSum
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                        />
                    )}
            </Box>
        </GridItem>
    );
};

export default CoveragePackageHouseInput;
